export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    set(state, items) {
      state.items = items;
    },

    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/claim-handlers')
          .then(response => {
            state.items = response.data;
          })
          .catch(err => {});
      }
    }
  },

  getters: {
    all(state) {
      return state.items;
    },

    drivers(state) {
      return state.items.filter(user => user.role === 'driver');
    },

    technicians(state) {
      return state.items.filter(user => user.role === 'vehicle_technician');
    }
  }
};
